import React from 'react';
import './ConfirmationModal.css';

/**
 * ConfirmationModal Component
 * A modal dialog for confirming actions (delete, etc.)
 */
const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  message,
  confirmText = 'OK',
  cancelText = 'Cancel',
}) => {
  const [busy, setBusy] = React.useState(false);

  if (!isOpen) return null;

  const handleConfirm = async () => {
    if (busy || !onConfirm) return;
    setBusy(true);
    try {
      await onConfirm();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={busy ? undefined : onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Confirm</h3>
        </div>
        <div className="modal-body">
          <p>{message}</p>
        </div>
        <div className="modal-footer">
          <button className="modal-btn modal-btn-cancel" onClick={onClose} disabled={busy}>
            {cancelText}
          </button>
          <button className="modal-btn modal-btn-confirm" onClick={handleConfirm} disabled={busy}>
            {busy ? 'Please wait...' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;

